module.exports = __webpack_public_path__ + "CambioAtqNoti.png";